"use strict";
'kiwi public';

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _sort = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/sort"));
var TextFormatting = _interopRequireWildcard(require("@/helpers/TextFormatting"));
var Misc = _interopRequireWildcard(require("@/helpers/Misc"));
var _GlobalApi = _interopRequireDefault(require("@/libs/GlobalApi"));
var _Html = _interopRequireDefault(require("@/libs/renderers/Html"));
var _MessageParser = _interopRequireDefault(require("@/libs/MessageParser"));
var _UserAvatar = _interopRequireDefault(require("./UserAvatar"));
var _AwayStatusIndicator = _interopRequireDefault(require("./AwayStatusIndicator"));
function _interopRequireWildcard(e, t) { if ("function" == typeof _WeakMap) var r = new _WeakMap(), n = new _WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && _Object$getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var CHATLATINOS_PROFILE_API = 'https://www.chatlatinos.org/admin/includes/process.php?action=kiwi_profile&nick=';
var _default = exports.default = {
  components: {
    UserAvatar: _UserAvatar.default,
    AwayStatusIndicator: _AwayStatusIndicator.default
  },
  props: ['network', 'buffer', 'user', 'sidebarState'],
  data: function data() {
    return {
      self: this,
      whoisRequested: false,
      whoisLoading: false,
      inviteChan: '',
      chatlatinosProfile: null,
      chatlatinosProfileLoading: false,
      chatlatinosProfileError: false,
      chatlatinosProfileRequestId: 0,
      profileDetailsOpen: false,
      pluginUiButtonElements: _GlobalApi.default.singleton().userboxButtonPlugins,
      pluginUiInfoElements: _GlobalApi.default.singleton().userboxInfoPlugins,
      pluginUiWhoisElements: _GlobalApi.default.singleton().userboxWhoisPlugins
    };
  },
  computed: {
    availableChannelModes: function availableChannelModes() {
      var availableModes = [];
      var prefixes = this.network.ircClient.network.options.PREFIX;
      var knownPrefix = {
        q: 'Owner',
        a: 'Admin',
        o: 'Operator',
        h: 'Half-Operator',
        v: 'Voice'
      };
      prefixes.forEach(function (prefix) {
        var mode = prefix.mode;
        if (knownPrefix[mode]) {
          availableModes.push({
            mode: mode,
            description: knownPrefix[mode]
          });
        }
      });
      return availableModes;
    },
    areWeAnOp: function areWeAnOp() {
      if (!this.buffer) {
        return false;
      }
      return this.buffer.isUserAnOp(this.buffer.getNetwork().nick);
    },
    realname: function realname() {
      var _context;
      return (0, _trim.default)(_context = this.user.realname || '').call(_context);
    },
    formattedRealname: function formattedRealname() {
      var blocks = (0, _MessageParser.default)(this.realname, {
        extras: false
      });
      var content = (0, _Html.default)(blocks, false);
      return content;
    },
    profileTitle: function profileTitle() {
      if (this.profileLoading) {
        return 'CARGANDO PERFIL';
      }
      if (!this.isUserIdentified) {
        return 'USUARIO NO IDENTIFICADO';
      }
      if (this.profileRegistered) {
        return 'USUARIO VERIFICADO';
      }
      if (this.profileError) {
        return 'PERFIL NO DISPONIBLE';
      }
      return 'USUARIO NO REGISTRADO';
    },
    profileTitleIcon: function profileTitleIcon() {
      if (this.profileLoading) {
        return '⏳';
      }
      if (!this.isUserIdentified) {
        return '🔒';
      }
      if (this.profileRegistered) {
        return '✅';
      }
      if (this.profileError) {
        return '⚠️';
      }
      return '❌';
    },
    profileSubtitle: function profileSubtitle() {
      if (this.profileLoading) {
        return 'Consultando estado del perfil';
      }
      if (!this.isUserIdentified) {
        return 'Debe identificarse para ver datos del perfil';
      }
      if (this.profileRegistered) {
        return this.userAccountName ? 'Cuenta: ' + this.userAccountName : 'Cuenta identificada';
      }
      if (this.profileError) {
        return 'Información no disponible';
      }
      return 'Sin perfil público registrado';
    },
    profileLoading: function profileLoading() {
      return this.chatlatinosProfileLoading;
    },
    profileError: function profileError() {
      return this.chatlatinosProfileError;
    },
    userAccountName: function userAccountName() {
      var _context2;
      var account = (0, _trim.default)(_context2 = String(this.user && this.user.account || '')).call(_context2);
      return account === '*' || account === '0' ? '' : account;
    },
    profileLookupName: function profileLookupName() {
      return this.cleanProfileNick(this.userAccountName || '');
    },
    isUserIdentified: function isUserIdentified() {
      return !!this.userAccountName;
    },
    profileCanShowPrivateInfo: function profileCanShowPrivateInfo() {
      return this.isUserIdentified;
    },
    profileRegistered: function profileRegistered() {
      return !!(this.isUserIdentified && this.chatlatinosProfile && this.chatlatinosProfile.registered);
    },
    profileCountry: function profileCountry() {
      var country = this.profileField('country');
      var city = this.profileField('city');
      if (country === '-' && city === '-') {
        return '-';
      }
      if (country !== '-' && city !== '-') {
        return country + ' / ' + city;
      }
      return country !== '-' ? country : city;
    },
    profileRegisteredAt: function profileRegisteredAt() {
      if (!this.profileRegistered) {
        return '-';
      }
      return this.profileField('registered_at');
    },
    profileCompactTitle: function profileCompactTitle() {
      if (this.profileRegistered) {
        return this.profileField('gender') !== '-' ? this.profileField('gender') : 'Perfil disponible';
      }
      if (this.profileError) {
        return 'Perfil no disponible';
      }
      return 'Perfil privado';
    },
    profileCompactText: function profileCompactText() {
      if (this.profileRegistered) {
        var country = this.profileCountry !== '-' ? this.profileCountry : 'Sin ubicación';
        var interests = this.profileField('interests');
        return interests !== '-' ? country + ' · ' + interests : country;
      }
      if (this.profileError) {
        return 'Inténtalo nuevamente con Más información';
      }
      return this.userAccountName ? 'Cuenta: ' + this.userAccountName : 'Sin cuenta identificada';
    },
    profileRows: function profileRows() {
      return [{
        key: 'gender',
        icon: '⚧',
        label: 'Género',
        value: this.profileField('gender')
      }, {
        key: 'interests',
        icon: '👥',
        label: 'Me interesa',
        value: this.profileField('interests')
      }, {
        key: 'looking_for',
        icon: 'ℹ️',
        label: 'Yo quiero',
        value: this.profileField('looking_for')
      }, {
        key: 'country',
        icon: '📍',
        label: 'País',
        value: this.profileCountry
      }, {
        key: 'about',
        icon: '🪪',
        label: 'Acerca de mí',
        value: this.profileField('about'),
        wide: true
      }, {
        key: 'registered_at',
        icon: '®',
        label: 'Registrado',
        value: this.profileRegisteredAt,
        wide: true
      }];
    },
    isUserOnBuffer: function isUserOnBuffer() {
      if (!this.buffer) {
        return false;
      }
      if (!this.user.buffers[this.buffer.id]) {
        return false;
      }
      return true;
    },
    userMode: {
      get: function get() {
        if (!this.buffer) {
          return '';
        }
        var userBufferInfo = this.user.buffers[this.buffer.id];
        if (!userBufferInfo) {
          return '';
        }
        var modes = userBufferInfo.modes;
        return modes.length > 0 ? modes[0] : '';
      },
      set: function set(newVal) {
        var _context3;
        var client = this.network.ircClient;
        var oldVal = this.userMode;
        var changes = [];
        var targets = [];
        if (oldVal) {
          changes.push('-' + oldVal);
          targets.push(this.user.nick);
        }
        if (newVal) {
          changes.push('+' + newVal);
          targets.push(this.user.nick);
        }
        var params = (0, _concat.default)(_context3 = ['MODE', this.buffer.name, changes.join('')]).call(_context3, targets);
        client.raw(params);
      }
    },
    userChannels: function userChannels() {
      var _context4, _context5;
      var channels = (0, _sort.default)(_context4 = (0, _trim.default)(_context5 = this.user.whois.channels).call(_context5).split(' ')).call(_context4, Misc.strCompare);
      for (var i = 0; i < channels.length; i++) {
        channels[i] = TextFormatting.linkifyChannels(channels[i]);
      }
      return channels.join(' ');
    },
    isSelf: function isSelf() {
      return this.user === this.network.currentUser();
    },
    invitableBuffers: function invitableBuffers() {
      var _this = this;
      var buffers = [];
      this.network.buffers.forEach(function (buffer) {
        if (buffer.isChannel() && buffer.isUserAnOp(_this.network.nick) && !buffer.hasNick(_this.user.nick)) {
          buffers.push(buffer.name);
        }
      });
      return buffers;
    }
  },
  watch: {
    user: function user() {
      this.whoisRequested = false;
      this.whoisLoading = false;
      this.loadChatlatinosProfile();
    },
    userAccountName: function userAccountName() {
      this.loadChatlatinosProfile();
    },
    profileLookupName: function profileLookupName() {
      this.loadChatlatinosProfile();
    }
  },
  mounted: function mounted() {
    this.loadChatlatinosProfile();
  },
  methods: {
    profileField: function profileField(field) {
      var _context6;
      if (!this.chatlatinosProfile || !this.chatlatinosProfile[field]) {
        return '-';
      }
      var value = (0, _trim.default)(_context6 = String(this.chatlatinosProfile[field] || '')).call(_context6);
      return value || '-';
    },
    cleanProfileNick: function cleanProfileNick(nick) {
      var _context7;
      return (0, _trim.default)(_context7 = String(nick || '').replace(/^[@+~&%]+/, '')).call(_context7);
    },
    loadChatlatinosProfile: function loadChatlatinosProfile() {
      var _this2 = this;
      var lookupName = this.profileLookupName;
      var requestId = this.chatlatinosProfileRequestId + 1;
      this.chatlatinosProfileRequestId = requestId;
      this.chatlatinosProfile = null;
      this.chatlatinosProfileError = false;
      if (!lookupName || !this.isUserIdentified) {
        this.chatlatinosProfileLoading = false;
        this.chatlatinosProfile = {
          registered: false
        };
        return;
      }
      this.chatlatinosProfileLoading = true;
      fetch(CHATLATINOS_PROFILE_API + encodeURIComponent(lookupName), {
        method: 'GET',
        credentials: 'omit',
        cache: 'no-store'
      }).then(function (response) {
        if (!response.ok) {
          throw new Error('Profile request failed');
        }
        return response.json();
      }).then(function (data) {
        if (requestId !== _this2.chatlatinosProfileRequestId) {
          return;
        }
        if (!data || data.ok === false) {
          _this2.chatlatinosProfile = {
            registered: false
          };
          _this2.chatlatinosProfileError = true;
        } else {
          _this2.chatlatinosProfile = data;
        }
      }).catch(function () {
        if (requestId !== _this2.chatlatinosProfileRequestId) {
          return;
        }
        _this2.chatlatinosProfile = {
          registered: false
        };
        _this2.chatlatinosProfileError = true;
      }).then(function () {
        if (requestId !== _this2.chatlatinosProfileRequestId) {
          return;
        }
        _this2.chatlatinosProfileLoading = false;
      });
    },
    openQuery: function openQuery() {
      this.sidebarState.showNicklist();
      var buffer = this.$state.addBuffer(this.network.id, this.user.nick);
      this.$state.setActiveBuffer(this.network.id, buffer.name);
      if (this.$state.ui.is_narrow) {
        this.$state.$emit('userbox.hide');
      }
    },
    onChannelsClick: function onChannelsClick(event) {
      var channelName = event.target.getAttribute('data-channel-name');
      if (channelName) {
        var network = this.buffer.getNetwork();
        this.$state.addBuffer(this.buffer.networkid, channelName);
        network.ircClient.join(channelName);
      }
    },
    updateWhoisData: function updateWhoisData() {
      var _this3 = this;
      this.whoisRequested = true;
      this.whoisLoading = true;
      this.network.ircClient.whois(this.user.nick, function () {
        _this3.whoisLoading = false;
      });
    },
    inviteUser: function inviteUser() {
      if (!this.inviteChan) {
        return;
      }
      this.network.ircClient.invite(this.inviteChan, this.user.nick);
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["UserBox"]
window._kiwi_exports.components.UserBox = exports.default ? exports.default : exports;
